/**
 * Custom "Raffle Points" glyph — a raffle ticket (with a punch-hole stub) carrying
 * a star, so points read as "reward tickets" without spelling the words out.
 * Inherits color via `currentColor`; set the parent text color to tint it.
 */
import type { CSSProperties } from 'react';

export function RafflePointsIcon({ size = 16, className = '', style }: { size?: number; className?: string; style?: CSSProperties }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            style={style}
            role="img"
            aria-label="Raffle points"
        >
            {/* ticket body */}
            <rect x="2.5" y="6.5" width="19" height="11" rx="2.6" fill="currentColor" fillOpacity="0.14" stroke="currentColor" strokeWidth="1.5" />
            {/* punch-hole stub */}
            <circle cx="6" cy="9.7" r="0.95" fill="currentColor" />
            {/* reward star */}
            <path
                d="M13 9.3 L13.68 11.26 L15.76 11.30 L14.10 12.56 L14.70 14.55 L13 13.36 L11.30 14.55 L11.90 12.56 L10.24 11.30 L12.32 11.26 Z"
                fill="currentColor"
            />
        </svg>
    );
}
